
import Vue from "vue";
import { mapState } from "vuex";
import { download } from "@/utils";

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    ...mapState("app", {
      language: "language",
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      url: "url",
      oss: "oss"
    }),
    images01(): string[] {
      return [
        this.oss.am_rgb_65_r1_5_39,
        this.oss.am_rgb_65_r1_5_40,
        this.oss.am_rgb_65_r1_5_41,
        this.oss.am_rgb_65_r1_5_42,
        this.oss.am_rgb_65_r1_5_43
      ];
    },
    images02(): string[] {
      return [this.oss.am_rgb_65_r1_5_44, this.oss.am_rgb_65_r1_5_45];
    },
    images03(): string[] {
      return [this.oss.am_rgb_65_r1_5_46, this.oss.am_rgb_65_r1_5_47];
    },
    images04(): string[] {
      return [
        this.oss.am_rgb_65_r1_5_48,
        this.oss.am_rgb_65_r1_5_49,
        this.oss.am_rgb_65_r1_5_50,
        this.oss.am_rgb_65_r1_5_51
      ];
    }
  },
  methods: {
    onDownload() {
      download(this.oss.pdf_am_rgb_65);
    },
    onVerify() {
      window.open(this.$paths.verify + "cyberboard/", "_blank");
    }
  }
});
